//
//
//
//
//
//
//
//
//
//
//
//
//

import {PortalTarget} from "portal-vue";
import GlobalSnackbar from '../../components/Snackbar/GlobalSnackbar';
import GlobalPopupAlert from '../../components/Popup/GlobalPopupAlert';

export default {
    name: "App",

    components: {PortalTarget, GlobalSnackbar, GlobalPopupAlert}
}
